import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  FaArrowLeft,
  FaComment,
  FaPhone,
  FaPlus,
  FaTrash,
} from "react-icons/fa";
import { BsChatDotsFill } from "react-icons/bs";
import { IoCall } from "react-icons/io5";
import { FaVideo } from "react-icons/fa6";
import { RiDeleteBin6Line } from "react-icons/ri";

import { LuUpload, LuAsterisk, LuUser, LuUsers } from "react-icons/lu";
import AvailabilitySchedule from "./AvailabilitySchedule";
import { useDispatch } from "react-redux";
import { createCreatorSession } from "../../redux/actions/mindfulness";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { handleSuccessMessage } from "../../redux/actions/success";

const SessionCreationForm = () => {
  const [formData, setFormData] = useState({
    sessionTitle: "",
    category: "",
    description: "",
    sessionType: "chat",
    price: "500",
    duration: "",
    objectives: [""],
    requirements: "",
    maxBookings: "5",
    activateImmediately: true,
    availability: {
      days_of_week: [1, 2, 3, 4, 5, 6],
      start_time: "2025-12-28T06:30:00Z",
      end_time: "2026-01-31T08:00:00Z",
      slot_interval: 20,
    },
    meetingLink:"",
  });

  const [isLoading, setIsLoading] = useState();
  const [availabilityData, setAvailabilityData] = useState(null);

  const dispatch = useDispatch();
  const history = useHistory();

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAddObjective = () => {
    setFormData((prev) => ({
      ...prev,
      objectives: [...prev.objectives, ""],
    }));
  };

  const handleObjectiveChange = (index, value) => {
    const newObjectives = [...formData.objectives];
    newObjectives[index] = value;
    setFormData((prev) => ({
      ...prev,
      objectives: newObjectives,
    }));
  };

  const handleRemoveObjective = (index) => {
    if (formData.objectives.length <= 1) return;

    const newObjectives = formData.objectives.filter((_, i) => i !== index);
    setFormData((prev) => ({
      ...prev,
      objectives: newObjectives,
    }));
  };

  const handleSessionTypeChange = (type) => {
    setFormData((prev) => ({
      ...prev,
      sessionType: type,
    }));
  };

  const handleSubmit = async () => {
    let payload = {
      name: formData.sessionTitle,
      category: formData.category,
      objective: formData.objectives[0],
      // duration: Number(formData.duration),
      max_booking_per_day: Number(formData.maxBookings),
      is_live: formData.activateImmediately,
      conversation_type_amount: {
        [formData.sessionType]: Number(formData.price),
      },
      availability: availabilityData || {
        availability_type: "weekly",
        days_of_week: [1, 2, 3, 4, 5],
        time_slots: [
          { start: "09:00:00", end: "17:00:00" }
        ],
      },
      duration: Number(availabilityData.duration),
      setting_config: {
        language: "English",
        level: "Beginner",
      },
      meet_link: formData.meetingLink,
    };

    console.log("Form submitted:", payload);

    try {
      setIsLoading(true);
      await dispatch(createCreatorSession(payload));
      handleSuccessMessage("Session Created Successfully")
      history.push("/creator_dashboard")
    } catch (error) {
      console.error("Error creating session", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleScheduleSave = (data) => {
    console.log("schedule data", data);
    setAvailabilityData(data);
  };

  const previewData = {
    title: formData.sessionTitle || "Your Session Title",
    description:
      formData.description || "Your session description will appear here...",
    category: formData.category || "Category",
    duration: formData.duration || "60 min",
    price: formData.price || "₹0",
  };

  // useEffect(() => {}, []);

  return (
    <Container>
      {/* <Header>
        <BackButton>
          <FaArrowLeft /> Dashboard
        </BackButton>
      </Header> */}

      <FormWrapper>
        {/* Basic Information Section */}
        <Section>
          <SectionTitle>Basic Information</SectionTitle>

          <FormField>
            <Label>
              Session Title <LuAsterisk color="#fb2c36" />
            </Label>
            <Input
              name="sessionTitle"
              value={formData.sessionTitle}
              onChange={handleInputChange}
              placeholder="e.g., Anxiety Management Session"
            />
          </FormField>

          <FormField>
            <Label>
              Category <LuAsterisk color="#fb2c36" />
            </Label>
            <Input
              name="category"
              value={formData.category}
              onChange={handleInputChange}
              placeholder=""
            />
          </FormField>

          <FormField>
            <Label>
              Description <LuAsterisk color="#fb2c36" />
            </Label>
            <TextArea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Describe what this session is about and what participants will gain..."
              rows="4"
            />
          </FormField>
        </Section>

        {/* Session Type & Pricing Section */}
        <Section>
          <SectionTitle>Session Type & Pricing</SectionTitle>

          <FormField>
            <Label>
              Session Type <LuAsterisk color="#fb2c36" />
            </Label>
            <SessionTypeContainer>
              <SessionTypeOption
                onClick={() => handleSessionTypeChange("chat")}
                active={formData.sessionType === "chat"}
              >
                <BsChatDotsFill size={28} />
                <span>Chat</span>
              </SessionTypeOption>

              <SessionTypeOption
                onClick={() => handleSessionTypeChange("call")}
                active={formData.sessionType === "call"}
              >
                <IoCall size={28} />
                <span>Call</span>
              </SessionTypeOption>

              <SessionTypeOption
                onClick={() => handleSessionTypeChange("video")}
                active={formData.sessionType === "video"}
              >
                <FaVideo size={28} />
                <span>Video</span>
              </SessionTypeOption>
            </SessionTypeContainer>
          </FormField>

          <PricingRow>
            <PriceField>
              <Label>
                Price (₹) <LuAsterisk color="#fb2c36" />
              </Label>
              <Input
                name="price"
                value={formData.price}
                onChange={handleInputChange}
                type="number"
                placeholder="500"
              />
            </PriceField>

            {/* <DurationField>
              <Label>
                Duration <LuAsterisk color="#fb2c36" />
              </Label>
              <Input
                name="duration"
                value={formData.duration}
                onChange={handleInputChange}
                placeholder=""
              />
            </DurationField> */}
          </PricingRow>
        </Section>

        {/* Session Objectives Section */}
        <Section>
          <SectionTitle>
            Session Objectives (Optional)
            {/* <AddObjectiveButton onClick={handleAddObjective}>
              <FaPlus /> Add Objective
            </AddObjectiveButton> */}
          </SectionTitle>

          {formData.objectives.map((objective, index) => (
            <ObjectiveRow key={index}>
              <ObjectiveInput
                value={objective}
                onChange={(e) => handleObjectiveChange(index, e.target.value)}
                placeholder={`Objective ${index + 1}`}
              />
              {formData.objectives.length > 1 && (
                <RemoveObjectiveButton
                  onClick={() => handleRemoveObjective(index)}
                >
                  <RiDeleteBin6Line color="#ED1E24" size={20} />
                </RemoveObjectiveButton>
              )}
            </ObjectiveRow>
          ))}
        </Section>

        {/* Requirements & Settings Section */}
        <Section>
          <SectionTitle>Requirements & Settings</SectionTitle>

          <FormField>
            <Label>Requirements or Prerequisites (Optional)</Label>
            <TextArea
              name="requirements"
              value={formData.requirements}
              onChange={handleInputChange}
              placeholder="Any specific requirements participants should know about..."
              rows="3"
            />
          </FormField>

          <FormField>
            <Label>Max Bookings Per Day</Label>
            <Input
              name="maxBookings"
              value={formData.maxBookings}
              onChange={handleInputChange}
              type="number"
              placeholder="5"
            />
          </FormField>

          {formData.sessionType != "chat" && <FormField>
            <Label>Meeting Link</Label>
            <Input
              name="meetingLink"
              value={formData.meetingLink}
              onChange={handleInputChange}
              type="url"
              placeholder="https://meet.google.com/your-session"
            />
          </FormField>}

          {/* <ActivationToggle>
            <ToggleLabel>
              <ToggleCheckbox
                type="checkbox"
                name="activateImmediately"
                checked={formData.activateImmediately}
                onChange={handleInputChange}
              />
              <ToggleText>
                Activate session immediately
                <ToggleSubtext>
                  Users can book this session right away
                </ToggleSubtext>
              </ToggleText>
            </ToggleLabel>
          </ActivationToggle> */}
        </Section>

        {/* Availability Schedule */}
        <AvailabilitySchedule onSave={handleScheduleSave} />

        {/* Session Preview Section */}
        <PreviewSection>
          <SectionTitle color="#1447E6">Session Preview</SectionTitle>
          <PreviewCard>
            <PreviewTitle>{previewData.title}</PreviewTitle>
            <PreviewDescription>{previewData.description}</PreviewDescription>
            <PreviewMeta>
              <MetaTag>{previewData.category}</MetaTag>
              <MetaInfo>{previewData.duration}</MetaInfo>
              <MetaPrice>₹{previewData.price}</MetaPrice>
            </PreviewMeta>
          </PreviewCard>
        </PreviewSection>

        {/* Action Buttons */}
        <ActionButtons>
          <CancelButton>Cancel</CancelButton>
          <CreateButton onClick={handleSubmit}>Create Session</CreateButton>
        </ActionButtons>
      </FormWrapper>
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  font-family: Montserrat;
  margin: 0 auto;
  padding: 1.25rem;
  /* background-color: #f8f9fa; */
  margin-top: 120px;
  width: 80%;
  border-radius: 15px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  background: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  margin-bottom: 2rem;
`;

const Header = styled.div`
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #dee2e6;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    color: #495057;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Section = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  box-sizing: border-box;
  border: 1px solid rgba(229, 231, 235, 1);
  border-radius: 14px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1),
    0px 1px 2px -1px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 1);
  padding: 1.25rem;
  margin-bottom: 0.5rem;
`;

const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
  color: ${(props) => props.color || "#0a0a0a"};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AddObjectiveButton = styled.button`
  background: none;
  border: none;
  color: #dc3545;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    text-decoration: underline;
  }
`;

const FormField = styled.div`
  margin-bottom: 15px;
  box-sizing: border-box;
`;

const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 400;
  margin-bottom: 5px;
  color: #495057;
  display: flex;
  align-items: center;

  .required {
    color: #dc3545;
    margin-left: 2px;
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 10px;
  font-size: 14px;
  transition: border-color 0.2s;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 10px;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

const SessionTypeContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-bottom: 15px;
  justify-content: flex-start;
`;

const SessionTypeOption = styled.div`
  flex: 1;
  padding: 1.75rem 1rem;
  border: 1px solid ${(props) => (props.active ? "#dc3545" : "#ced4da")};
  border-radius: 14px;
  background-color: ${(props) => (props.active ? "#fff0f0" : "white")};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  /* width: 20%; */

  span {
    font-size: 14px;
    font-weight: 400;
    margin-top: 1rem;
  }

  &:hover {
    border-color: #007bff;
    background-color: ${(props) => (props.active ? "#fff0f0" : "#e9ecef")};
  }
`;

const PricingRow = styled.div`
  display: flex;
  gap: 15px;
`;

const PriceField = styled.div`
  flex: 1;
`;

const DurationField = styled.div`
  flex: 1;
`;

const ObjectiveRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;

  box-sizing: border-box;
  border: 1px solid rgba(209, 213, 220, 1);
  border-radius: 10px;
`;

const ObjectiveInput = styled.input`
  flex: 1;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

const RemoveObjectiveButton = styled.button`
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;

  &:hover {
    background-color: #f8f9fa;
    color: #dc3545;
  }
`;

const ActivationToggle = styled.div`
  margin-top: 15px;
`;

const ToggleLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
`;

const ToggleCheckbox = styled.input`
  width: 20px;
  height: 20px;
  margin-right: 0.75rem;
  cursor: pointer;
`;

const ToggleText = styled.div`
  flex: 1;
  font-size: 1rem;
  font-weight: 400;
`;

const ToggleSubtext = styled.div`
  font-size: 12px;
  color: #6c757d;
  margin-top: 3px;
  font-weight: 400;
`;

const PreviewSection = styled.div`
  background-color: #e3f2fd;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;

  box-sizing: border-box;
  border: 1px solid rgba(190, 219, 255, 1);
  border-radius: 14px;
  background: linear-gradient(
    135deg,
    rgba(238.92, 245.83, 254.71, 1),
    rgba(218.85, 234.05, 254.3, 1) 100%
  );
`;

const PreviewCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const PreviewTitle = styled.h3`
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 8px;
  color: #0a0a0a;
`;

const PreviewDescription = styled.p`
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 15px;
  line-height: 1.5;
`;

const PreviewMeta = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
`;

const MetaTag = styled.span`
  background-color: #e3f2fd;
  color: #1447e6;
  padding: 8px 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 400;
`;

const MetaInfo = styled.span`
  font-size: 0.875rem;
  font-weight: 400;
  color: #6c757d;
`;

const MetaPrice = styled.span`
  font-size: 0.875rem;
  font-weight: 400;
  color: #00a63e;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  margin-bottom: 2rem;
`;

const CancelButton = styled.button.attrs({ type: 'button' })`
  flex: 1;
  padding: 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: white;
  color: #0a0a0a;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-weight: 500;

  box-sizing: border-box;
  border: 1px solid rgba(209, 213, 220, 1);
  border-radius: 10px;

  &:hover {
    background-color: #e9ecef;
  }
`;

const CreateButton = styled.button.attrs({ type: 'button' })`
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 4px;
  background-color: #d1d5dc;
  color: #0a0a0a;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-weight: 500;

  border-radius: 10px;
  background: rgba(209, 213, 220, 1);

  &:hover {
    background-color: #495057;
  }

  &:disabled {
    background-color: #adb5bd;
    cursor: not-allowed;
  }
`;

export default SessionCreationForm;
